module.exports = __webpack_public_path__ + "static/media/phone.d6850a2b.svg";